import React from "react";
import { useTheme } from "styled-components";
import Svg from "../Svg";

const Icon = (props) => {
  const theme = useTheme();
  const { size } = props;
  return (
    <Svg
      width={size ?? 16}
      height={size ?? 16}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.0001 0.333344C6.10091 0.334329 4.26401 1.00698 2.81783 2.23103C1.37166 3.45507 0.410521 5.15068 0.106282 7.01468C-0.197958 8.87867 0.174536 10.7895 1.15717 12.4055C2.13979 14.0214 3.66848 15.2372 5.46987 15.8353C5.86729 15.9091 6.01698 15.6628 6.01698 15.4533C6.01698 15.2439 6.00903 14.6367 6.00638 13.9728C3.78085 14.4536 3.31058 13.0337 3.31058 13.0337C2.9476 12.1116 2.42301 11.8693 2.42301 11.8693C1.69706 11.3766 2.47733 11.3859 2.47733 11.3859C3.28143 11.4425 3.70402 12.2065 3.70402 12.2065C4.41672 13.4222 5.57585 13.0705 6.03155 12.8651C6.10309 12.35 6.31107 11.9997 6.54025 11.8008C4.76247 11.6006 2.89461 10.9183 2.89461 7.87029C2.88359 7.07982 3.1786 6.31538 3.71859 5.73513C3.63646 5.53492 3.36224 4.72617 3.79675 3.62763C3.79675 3.62763 4.46839 3.41425 5.99712 4.44297C7.30836 4.08643 8.69183 4.08643 10.0031 4.44297C11.5305 3.41425 12.2008 3.62763 12.2008 3.62763C12.6366 4.72353 12.3624 5.53228 12.2803 5.73513C12.822 6.31547 13.1176 7.08124 13.1056 7.87293C13.1056 10.9275 11.2337 11.6006 9.45331 11.7968C9.73945 12.0445 9.99513 12.5279 9.99513 13.2708C9.99513 14.335 9.98585 15.1912 9.98585 15.4533C9.98585 15.6654 10.1302 15.913 10.5356 15.8353C12.3372 15.2371 13.866 14.0211 14.8487 12.4049C15.8313 10.7887 16.2036 8.87754 15.899 7.01338C15.5944 5.14921 14.6328 3.45358 13.1861 2.22975C11.7395 1.00591 9.90215 0.333704 8.00274 0.333344H8.0001Z"
        fill={theme.colors.foregroundHighEmphasis}
      />
    </Svg>
  );
};

export default Icon;
